import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Select from 'react-select';
import ReactQuill from 'react-quill';
import _ from 'lodash';
import 'react-quill/dist/quill.snow.css';
import { SECTIONS, NAMES } from '../../utils/progressReport';
import { formatMoney } from '../../utils/budget';
import ReadonlySchedule from './schedule_readonly';

const EMPTY_LIST = '<ul><li></li></ul>';

function getAttr (obj, attr) {
  return (obj && obj[attr]) ? obj[attr] : null;
}

function getMoney (obj, attr) {
  if (obj && obj[attr]) return formatMoney(obj[attr]);
  return 'Not specified';
}

const QuillProps = {
  modules: {
    toolbar: [
      [{'list': 'bullet'}],
      ['bold', 'italic', 'underline', 'strike', 'link'],
      [{'indent': '-1'}, {'indent': '+1'}],
    ],
  }
}

class ProgressReportForm extends React.Component {
  // static PropTypes = {
  //   projectId: PropTypes.string.isRequired,
  //   report: PropTypes.object.isRequired,
  //   info: PropTypes.object.isRequired,
  //   schedule: PropTypes.object.isRequired,
  //   divisionName: PropTypes.string.isRequired,
  //   onSubmit: PropTypes.func.isRequired,
  //   contracts: PropTypes.array.isRequired,
  // }

  constructor (props) {
    super(props);

    const { contractId } = props.report;
    const textFields = _.pick(props.report, SECTIONS)

    this.state = {
      contractId,
      ...textFields
    }

    this.handleSubmit = this.handleSubmit.bind(this)
    this.handleContractChange = this.handleContractChange.bind(this)
  }

  getContractOptions () {
    return this.props.contracts.map(contract => {
      return {
        label: `${contract.regNumber} - ${contract.contractor}`,
        value: contract.id
      }
    });
  }

  handleContractChange (option) {
    const contractId = option ? option.value : null;
    this.setState({ contractId });
  }

  handleChangeQuill (field) {
    return (value) => {
      this.setState({ [field]: value });
    }
  }

  handleSubmit (e) {
    e.preventDefault();

    if (!this.state.contractId) return;

    const staticTexts = {
      infoText: this.infoArea.outerHTML,
      scheduleText: this.scheduleArea.outerHTML,
      contractText: this.contractArea.outerHTML,
    }

    this.props.onSubmit({
      ...this.props.report,
      ...this.state,
      ...staticTexts,
    });
  }

  renderInfo (contract) {
    const { info } = this.props;

    return (
      <div ref={(el) => { this.infoArea = el }} className="section">
        <h2 className="project-title">
          {info.projectId}
          <span className="separator"/>
          {info.projectDescription}
        </h2>
        <div className="info">
          <div>
            <strong>FMS ID:</strong>
            <span>{getAttr(contract, 'fmsid')}</span>
          </div>
          <div>
            <strong>Borough:</strong>
            <span>{getAttr(contract, 'borough')}</span>
          </div>
          <div>
            <strong>Registration No.:</strong>
            <span>{getAttr(contract, 'regNumber')}</span>
          </div>
          <div>
            <strong>Type:</strong>
            <span>{getAttr(contract, 'type')}</span>
          </div>
        </div>
        <h2>SCOPE OF WORK</h2>
        <div className="info">
          {getAttr(contract, 'description')}
        </div>
      </div>
    );
  }

  renderSchedule () {
    return (
      <div ref={(el) => { this.scheduleArea = el }}
        className="section report-schedule">
        <h2>CONTRACT SCHEDULE</h2>
        <div className="info">
          <ReadonlySchedule
            schedule={this.props.schedule}
            divisionName={this.props.divisionName}
          />
        </div>
      </div>
    )
  }

  renderBudget (contract) {
    const duration = contract && contract.totalContractDuration;
    const percent = contract && contract.percentOfOriginalTimeElapsed;
    return (
      <div ref={(el) => { this.contractArea = el }} className="section">
        <h2>CONTRACT BUDGET</h2>
        <div className="info">
          <div>
            <strong>Original Contract Amount:</strong>
            <span>{getMoney(contract, 'originalContractAmount')}</span>
          </div>
          <div>
            <strong>Current Contract Amount:</strong>
            <span>{getMoney(contract, 'currentContractAmount')}</span>
          </div>
          <div>
            <strong>Total Contract Duration</strong>
            <span>{duration ? (duration + ' days') : '-'}</span>
          </div>
          <div>
            <strong>Percent Time Elapsed:</strong>
            <span>{percent ? (percent + '%') : '-'}</span>
          </div>
        </div>
      </div>
    );
  }

  render () {
    const { contractId } = this.state;
    const canSubmit = contractId && _.every(_.pick(this.state, SECTIONS));
    const contract = _.find(this.props.contracts, {id: contractId});

    return (
      <form className="modal-form" onSubmit={this.handleSubmit}>
        <h1>{this.props.report.title}</h1>

        <div className="control required">
          <label>Contract</label>
          <Select name="documentType"
            value={this.state.contractId}
            options={this.getContractOptions()}
            onChange={this.handleContractChange}
          />
        </div>

        { contract
          ? <div>
              {this.renderInfo(contract)}
              <div className="hide">{this.renderSchedule(contract)}</div>
              {this.renderBudget(contract)}
            </div>
          : null }

        { SECTIONS.map((section, index) =>
          <div key={section} className="control required">
            <label>{ NAMES[index].toUpperCase() }</label>
            <ReactQuill
              {...QuillProps}
              value={this.state[section] || EMPTY_LIST}
              onChange={this.handleChangeQuill(section)}
            />
          </div>
        )}
        <button className="btn-update" disabled={!canSubmit}>Update</button>
      </form>
    )
  }
}

ProgressReportForm.propTypes = {
  projectId: PropTypes.string.isRequired,
  report: PropTypes.object.isRequired,
  info: PropTypes.object.isRequired,
  schedule: PropTypes.object.isRequired,
  divisionName: PropTypes.string.isRequired,
  onSubmit: PropTypes.func.isRequired,
  contracts: PropTypes.array.isRequired
};

function mapStateToProps (state) {
  return {
    info: state.projectsStore.info,
    schedule: state.projectsStore.schedule,
    divisionName: state.projectsStore.divisionName,
  }
}

export default connect(mapStateToProps)(ProgressReportForm);